export function getCookie(name: string) {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

const isIpAddress = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;

export function setCookie(name: string, value: string, days: number, hours = 0, minutes = 0) {
    const d = new Date();
    let sndleveldomain;
    if (isIpAddress.test(location.hostname)) {
        sndleveldomain = location.hostname;
    } else {
        const parts = location.hostname.split('.');
        sndleveldomain = parts.slice(-2).join('.');
    }
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000 * days) + (60 * 60 * 1000 * hours) +  (60 * 1000 * minutes));
    const cookieStr = name + '=' + value + ';path=/;expires=' + d.toUTCString() + ';domain=.' + sndleveldomain;
    document.cookie = cookieStr;
}
export function deleteCookie(name: string) {
    setCookie(name, '', -1);
}
